<template>
  <main>
    <vue-headful
      title="Cours de japonais à Lyon"
      description="L'ADLCJ, forte de 30 ans d'expérience, propose plusieurs niveaux de cours, dans une limite de 20 personnes par cours et à partir de 16 ans. Un moyen économique et efficace pour acquérir de bonnes bases ou se perfectionner."
      url="https://adlcj.fr/cours-japonais"
      type="article"
      image="https://adlcj.fr/img/kingyo_cours_jap.2b7ecc28.svg"
      site_name="ADLCJ : Association pour le Développement de la Langue et de la Culture Japonaises"
    />
    <section class="title">
      <div class="title-wrapper">
        <h1>Cours de japonais pour adultes</h1>
      </div>
      <p>
        Premiers pas en japonais ou envie de vous perfectionner ?<br />
        L'ADLCJ, forte de 30 ans d'expérience, propose plusieurs niveaux de
        cours.
      </p>
      <div class="niveau5Banner">
        <h3>
          Nouveauté
          <img
            src="../assets/image/icons/emojione_sparkles.svg"
            alt=""
            aria-hidden="true"
            class="h3Icon"
          />
          - Niveau 5
        </h3>
        <p>
          Cette année, nous proposons une nouvelle classe pour consolider les
          bases avant le passage au niveau intermédiaire. Le cours sera adapté
          au niveau des participants et couvrira les points essentiels des
          leçons 30 à 50 de Minna no Nihongo, avec des exercices de conversation
          pratiques.
        </p>
      </div>
    </section>

    <section class="container coursMain">
      <!-- 1. Boutons flex -->
      <div class="buttonsRow">
        <div class="btnWithLabel">
          <span class="btnLabel btnLabel1"
            >Découvrez votre niveau du japonais</span
          >
          <ButtonSecondary
            label="Tester mon niveau"
            variant="gold"
            to="/cours-japonais/niveau"
          />
          <strong class="testLabel">
            <img
              src="../assets/image/icons/material-symbols_check-box_yellow.svg"
              alt=""
              aria-hidden="true"
              class="testLabelIcon"
            />
            Gratuit et résultat immédiat
          </strong>
        </div>
        <div class="btnWithLabel">
          <span class="btnLabel btnLabel2"
            >Inscrivez-vous ou découvrez notre cours d’essai</span
          >
          <ButtonSecondary
            label="Je m'inscris"
            variant="red"
            href="https://www.helloasso.com/associations/adlcj/boutiques/adlcj-cours-de-japonais-2026-2027"
            target="_blank"
          />
          <strong class="inscriptionOpen"
            >Les inscriptions 2026/2027 sont ouvertes !<br />
            (jusqu'au 7 septembre 2026)</strong
          >
        </div>
      </div>

      <!-- 2. Nos cours + Photo flex -->
      <div class="coursPhotoRow">
        
        <div class="section-wrapper main-section">
          <h2>Nos cours</h2>
          <ul class="coursList">
            <li>Ouvert à tout public, à partir de 16 ans</li>
            <li>Des groupes de 12 personnes maximum</li>
            <li>Tous nos enseignants sont des locuteurs natifs du japonais</li>
            <li>+ Activités culturelles*</li>
          </ul>
          <div class="activites">
            <p>
              *Dans l'année, deux activités culturelles sont proposées. Exemples
              d’activités proposées :
            </p>
            <ul class="activitesList">
              <li>Rencontre avec des Japonais autour de repas</li>
              <li>Jeux et danses traditionnels</li>
              <li>Origami</li>
              <li>Calligraphie</li>
              <li>Cérémonie du thé</li>
              <li>Kirigami</li>
            </ul>
          </div>
        </div>
        <div class="photosArea">
          <img
            src="../assets/image/kingyo_cours_jap.svg"
            class="kingyoDeco"
            alt=""
            aria-hidden="true"
          />
        </div>
      </div>

      <!-- 3. Info grid -->
<div class="infoGrid">
  <!-- Colonne gauche -->
  <div class="infoLeft">
    <!-- Séparateur avant Tarif -->
    <div class="infoSeparator">
      <img src="../assets/image/separateur.svg" alt="" />
    </div>

    <!-- Tarif -->
    <div class="section-wrapper center-section">
      <h2>Tarif 2026/2027</h2>
      <p>490 euros / an (28 séances)</p>
    </div>

    <!-- Séparateur après Tarif -->
    <div class="infoSeparator">
      <img src="../assets/image/separateur.svg" alt="" />
    </div>

    <!-- Horaires -->
    <div class="section-wrapper center-section">
      <h2>Horaires</h2>
      <p>Niveau 2, 5 : Mardi de 18h30 à 20h30</p>
      <p>Niveau 1, 3, 4 : Mercredi de 18h30 à 20h30</p>
      <p>(Hors vacances scolaires)</p>
    </div>

    <!-- Séparateur après Horaires -->
    <div class="infoSeparator">
      <img src="../assets/image/separateur.svg" alt="" />
    </div>

    <!-- Lieu -->
    <div class="section-wrapper center-section">
      <h2>Lieu</h2>
      <p>
        Lycée Charles de Foucauld<br />
        6 Rue Bara, 69003 Lyon
      </p>

      <a
        href="https://maps.app.goo.gl/nP3hLvSruXSfUGSo7"
        target="_blank"
        rel="noopener noreferrer"
        class="linkWithIcon"
      >
        <img
          src="../assets/image/icons/jump-link.svg"
          alt=""
          aria-hidden="true"
          class="linkIcon"
        />
        Voir sur Google Maps
      </a>
    </div>

  </div>

  <!-- Colonne droite -->
  <div class="section-wrapper levels-section">
    <!-- Séparateur au-dessus de Niveaux & Manuels -->
    <div class="infoSeparator levelsSeparator">
      <img src="../assets/image/separateur.svg" alt="" />
    </div>

    <h2>Niveaux & Manuels</h2>

    <p>
      Nous utilisons les manuels
      <em>Minna no Nihongo Shokyū I et II</em>.
    </p>

    <p>Début des cours par niveau :</p>

    <ul>
      <li>Niveau 1 : leçon 1</li>
      <li>Niveau 2 : leçon 9</li>
      <li>Niveau 3 : leçon 17</li>
      <li>Niveau 4 : leçon 23</li>
      <li>Niveau 5 : leçon 30</li>
    </ul>

    <p>Manuel à prévoir avant le premier cours :</p>

    <ul>
      <li>
        Niveau 1 à 4 : Minna no Nihongo Shokyū I <br />
        (ISBN 978-4883196036)
      </li>
      <li>
        Niveau 4, 5 : Minna no Nihongo Shokyū II <br />
        (ISBN 978-4883196463)
      </li>
    </ul>

    <div class="manuelPhoto">
      <img
        src="../assets/image/minnanonihongo.svg"
        alt="Manuels Minna no Nihongo Shokyū I et II"
      />
    </div>

  
</div>

    <div class="btnWrapper2 mobileBtnWrapper">
      <div class="btnWithLabel">
        <span class="btnLabel btnLabel1">
          Consultez notre test pour connaître votre niveau.
        </span>

        <ButtonSecondary
          label="Tester mon niveau"
          variant="gold"
          to="/cours-japonais/niveau"
        />
      </div>

      <div class="btnWithLabel">
        <span class="btnLabel btnLabel2">
          Nous proposons également un cours d'essai (payant).
        </span>

        <ButtonSecondary
          label="Cours d'essai"
          variant="red"
          href="https://www.helloasso.com/associations/adlcj/boutiques/adlcj-cours-de-japonais-2026-2027"
          target="_blank"
        />
      </div>
    </div>
  </div>

    </section>

    <section class="reviewsSection">
      <div class="sectionTitle">
        <h2>Ce que disent nos élèves</h2>
      </div>
      <div class="reviewsGrid">
        <div class="reviewCard">
          <div class="reviewStars">
            <span v-for="n in 5" :key="n" class="star">★</span>
          </div>
          <p class="reviewText">
            "Je recommande vivement l'ADLCJ. Chaque cours a été pour moi une
            façon de penser à autre chose que mes études et de plonger dans ma
            passion pour la langue et le pays."
          </p>
          <div class="reviewAuthor">
            <div>
              <span class="reviewName">Etienne</span>
              <span class="reviewBadge">Avis Google</span>
            </div>
          </div>
        </div>
        <div class="reviewCard">
          <div class="reviewStars">
            <span v-for="n in 5" :key="n" class="star">★</span>
          </div>
          <p class="reviewText">
            "C'est vraiment agréable de suivre les cours de japonais de
            l'ADLCJ."
          </p>
          <div class="reviewAuthor">
            <div>
              <span class="reviewName">Frédéric S.</span>
              <span class="reviewBadge">Avis Google</span>
            </div>
          </div>
        </div>
        <div class="reviewCard">
          <div class="reviewStars">
            <span v-for="n in 5" :key="n" class="star">★</span>
          </div>
          <p class="reviewText">
            "Un apprentissage du japonais dynamique, pédagogique et amusant.
            Professeure très impliquée et si sympathique !"
          </p>
          <div class="reviewAuthor">
            <div>
              <span class="reviewName">Valérie C.</span>
              <span class="reviewBadge">Avis Google</span>
            </div>
          </div>
        </div>
      </div>
      <div class="reviewsSeeAll">
        <a
          href="https://maps.app.goo.gl/XHrz7xaqRhV8BFW39"
          target="_blank"
          rel="noopener noreferrer"
          class="btnSeeAll linkWithIcon"
        >
          <img
            src="../assets/image/icons/jump-link.svg"
            alt=""
            aria-hidden="true"
            class="linkIcon"
          />
          Voir tous les avis sur Google
        </a>
      </div>
    </section>

    <div class="btnWithLabel contactBlock">
      <span class="btnLabel"
        >Besoin d'informations supplémentaires ? N'hésitez pas à nous contacter
        !</span
      >
      <ButtonSecondary label="Contact" variant="grey" to="/contact" />
    </div>
  </main>
</template>
<script>
import ButtonSecondary from "../components/ButtonSecondary.vue";

export default {
  components: { ButtonSecondary },
  beforeCreate() {
    this.$i18n.locale = "fr";
  },
  metaInfo: {
    meta: [
      { name: "og:url", content: "https://adlcj.fr/cours-japonais" },
      { name: "og:title", content: "Cours de japonais à Lyon" },
      {
        name: "og:description",
        content:
          "L'ADLCJ, forte de 30 ans d'expérience, propose plusieurs niveaux de cours, dans une limite de 20 personnes par cours et à partir de 16 ans. Un moyen économique et efficace pour acquérir de bonnes bases ou se perfectionner.",
      },
      {
        name: "og:site_name",
        content:
          "ADLCJ : Association pour le Développement de la Langue et de la Culture Japonaises",
      },
      {
        name: "og:image",
        content: "https://adlcj.fr/img/cours-de-japonais-4.6dc11017.jpg",
      },
    ],
  },
};
</script>

<style lang="scss" scoped>
a {
  color: $linkColor;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.btnWrapper {
  display: flex;
  gap: 30px;

  flex-wrap: wrap;

  > *:first-child {
    margin-right: 0;
  }
}

.btnWrapper2 {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.btnWithLabel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.btnLabel {
  font-size: 18px;
  font-weight: 600;
  color: $textColor;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 0.85rem;

  &::before {
    content: "";
    display: inline-block;
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  &.btnLabel1::before {
    background-image: url("../assets/image/icons/yellowRight.svg");
  }

  &.btnLabel2::before {
    background-image: url("../assets/image/icons/redRight.svg");
  }
}

.cta {
  border: 1px solid #ccc;
  padding: 15px;
  margin: 40px auto;

  .large {
    font-size: 1.3rem;
    margin-bottom: 0.9rem;
  }
}

.wrapPromo {
  position: relative;
}

.qrcode {
  position: absolute;
  left: 20px;
  bottom: 0;
  max-width: 120px;

  img {
    margin-bottom: 20px;
  }
}

.linkHelloAsso {
  position: absolute;
  bottom: -10px;
  right: 0;
}

.reviewsSection {
  max-width: 1000px;
  margin: 60px auto 0;
  padding: 0 20px;
}

.reviewsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 24px;
}

.reviewCard {
  background: white;
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.reviewStars {
  display: flex;
  gap: 2px;
}

.star {
  color: #fbbc04;
  font-size: 16px;
}

.reviewText {
  font-size: 0.9rem;
  line-height: 1.6;
  font-style: italic;
  flex: 1;
  margin: 0;
}

.reviewAuthor {
  display: flex;
  align-items: center;
  gap: 8px;
}

.reviewName {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: $textColor;
}

.reviewBadge {
  display: block;
  font-size: 0.75rem;
  color: #888;
}

.reviewsSeeAll {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.linkWithIcon {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.linkIcon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.btnSeeAll {
  font-size: 0.9rem;
  color: $linkColor;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 8px 20px;
  text-decoration: none;
  transition: background 0.15s;

  &:hover {
    background: #f5f5f5;
  }
}

/* ── Boutons flex ── */
.buttonsRow {
  display: flex;
  justify-content: space-around;
  gap: 40px;
  flex-wrap: wrap;
  max-width: 1000px;
  margin-bottom: 40px;
  padding: 0 20px;
}

.coursPhotoRow {
  display: flex;
  align-items: center;
  gap: 70px;
  flex-wrap: nowrap;
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 0 10px;

  .main-section {
    flex: 1;
    min-width: 0;
  }
}

.photosArea {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  min-width: 350px;
}

.kingyoDeco {
  width: 100%;
  max-width: 800px;
}

.main-section {
  ul > li::before {
    content: "";
    display: inline-block;
    flex-shrink: 0;
    width: 25px;
    height: 25px;
    margin-top: 2px;
    background-image: url("../assets/image/icons/material-symbols_check-box.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .activitesList {
    list-style-type: "– "; // tiret long
    padding-left: 20px;
    margin-top: 8px;

    li {
      display: list-item; // override le display:flex hérité de ul > li
    }

    li::before {
      display: none; // supprime complètement le ::before
    }
  }
  .coursList li {
    font-weight: 600;
  }
  .activitesList li::before {
    content: "";
    background-image: none;
    background-color: $textColor;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-top: 8px;
  }
}

/* ─────────────────────────────
   INFO GRID
   ───────────────────────────── */

.infoGrid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 100px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
  }

  p,
  li {
    text-align: left;
  }

  .center-section p {
    text-align: center;
  }
}

/* ─────────────────────────────
   COLONNE GAUCHE
   ───────────────────────────── */

.infoLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  .section-wrapper {
    width: 100%;
  }
}

/* ─────────────────────────────
   SÉPARATEURS
   ───────────────────────────── */

.infoSeparator {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  img {
    display: block;
    width: 80px;
    height: auto;
  }
}


/* ─────────────────────────────
   COLONNE DROITE
   ───────────────────────────── */

.levels-section {
  grid-column: 2;
  grid-row: 1;
  align-self: stretch;

  /*
   * Le séparateur est séparé du titre,
   * comme dans la colonne gauche.
   */
  .levelsSeparator {
    margin-bottom: 24px;
  }
}

/* ─────────────────────────────
   MOBILE
   ───────────────────────────── */

@media (max-width: 700px) {
  .infoGrid {
    grid-template-columns: 1fr;
    column-gap: 0;
    row-gap: 0;
    padding: 0 20px;
  }

  .infoLeft {
    gap: 20px;
  }

  .levels-section {
    grid-column: 1;
    grid-row: auto;
    margin-top: 20px;

    .levelsSeparator {
      margin-bottom: 20px;
    }
  }

  .infoSeparator {
    img {
      width: 70px;
      max-width: 100%;
    }
  }
  
}


/* ── Inscription ouverte ── */

.niveau5Banner {
  margin: 1.5rem auto;
  max-width: 800px;
  padding: 1rem 1.25rem;
  border: 2px solid $accentGold;
  border-radius: 10px;
  h3 {
    font-size: 1.25rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .h3Icon {
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
  }

  p {
    margin: 0;
    font-size: 1.25rem;
    line-height: 1.6;
    font-weight: 500;
  }

}

.inscriptionOpen {
  display: none ;
  color: $accentColor;
  font-size: 0.95rem;
  margin-top: 0.85rem;
}

.testLabel {
  font-size: 0.95rem;
  margin-top: 0.85rem;
  display: flex;
  align-items: center;
  gap: 6px;
}

.testLabelIcon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* ── Contact block en bas ── */
.contactBlock {
  margin: 60px auto;
  text-align: center;

  .btnLabel::before {
    display: none;
  }
}

.btnWrapper2.mobileBtnWrapper {
  display: none;
}
/* ── Responsive ── */

@media (max-width: 700px) {
  .btnLabel {
    display: block;

    &::before {
      display: inline-block;
      vertical-align: middle;
      margin-right: 4px;
    }
  }
  .btnWrapper2.mobileBtnWrapper {
    display: flex;
  }
  .buttonsRow {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
  .niveau5Banner {
    margin: 1rem 20px;
    padding: 0.8rem 1rem;
    border-radius: 8px;

    h3 {
      font-size: 1.1rem;
      line-height: 1.3;
      text-align: center;
      justify-content: center;
      gap: 5px;
    }

    .h3Icon {
      width: 0.9rem;
      height: 0.9rem;
    }

    p {
      font-size: 0.9rem;
      line-height: 1.5;
      text-align: left;
    }
  }
  .coursPhotoRow {
    flex-direction: column;
    gap: 30px;
    padding: 0 20px;
  }

  .photosArea {
    min-width: 0;
    width: 100%;
    justify-content: center;
  }

  .kingyoDeco {
    width: 100%;
    max-width: 260px;
  }

  .section-wrapper.main-section .activitesList li {
    font-size: 16px;
  }

  @media (max-width: 700px) {
  /* =========================
     TYPOGRAPHIE MOBILE
     ========================= */

  body {
    font-size: 15px;
  }

  

  h2 {
    font-size: 1rem;
    line-height: 1.3;
  }

  h3 {
    font-size: 1.1rem;
    line-height: 1.3;
  }

  p,
  li {
    font-size: 0.95rem;
    line-height: 1.6;
  }

  /* Hero / présentation */
  .hero-text {
    font-size: 0.95rem;
    line-height: 1.6;
  }
.btnLabel {
    font-size: 1rem;
  }
  /* Sections */
  .section-wrapper {
    h2 {
      font-size: 1.2rem;
    }

    p,
    li {
      font-size: 0.95rem;
    }
  }

  /* Tarif / horaires / lieu */
  .center-section {
    h2 {
      font-size: 1.2rem;
    }

    p {
      font-size: 0.95rem;
    }
  }

  /* Niveaux & Manuels */
  .levels-section {
    h2 {
      font-size: 1.2rem;
    }

    p,
    li {
      font-size: 0.95rem;
      line-height: 1.6;
    }
  }
  .manuelPhoto img {
    max-width: 200px;
  }

  /* Boutons */
  button,
  .btn,
  a.btn {
    font-size: 0.9rem;
  }

  /* Liens */
  a {
    font-size: 0.9rem;
  }
}
}
</style>
